import React from 'react';
import './Courses.css';
import pythonImage from '../../images/python.svg';
import reportImage from '../../images/report.svg';
import awsImage from '../../images/aws.svg';

const courses = [
  {
    title: 'AWS para Análisis Big Data',
    instructor: 'Arturo Lorenzo',
    imageUrl: awsImage,
    url: 'https://www.udemy.com/course/aws-para-analistas-de-datos-total-en-7-dias/',
    available: true,
    isNew: true,
  },
  {
    title: 'Análisis de datos con Python',
    instructor: 'Arturo Lorenzo',
    imageUrl: reportImage,
    url: 'https://www.udemy.com/course/analisis-de-datos-con-python-total-en-7-dias/',
    available: true,
    isNew: false,
  },
  {
    title: 'Python desde cero',
    instructor: 'Arturo Lorenzo',
    imageUrl: pythonImage,
    url: 'https://www.udemy.com/course/python-desde-cero-hasta-nivel-experto/',
    available: true,
    isNew: false,
  },
];

const Courses = () => (
  <section id="cursos">
    <h2 className="section-heading">cursos</h2>
    <div className="courses-grid">
      {courses.map((course) => (
        <div key={course.url} className="course-card">
          <img src={course.imageUrl} alt={course.title} className="course-img" />
          <h3 className="course-title">{course.title}</h3>
          <p className="course-instructor">Instructor: {course.instructor}</p>
          {course.isNew && <span className="course-badge">¡Recién lanzado! 🔥</span>}
          {course.available ? (
            <a href={course.url} target="_blank" rel="noreferrer" className="btn-cta">
              Ver más
            </a>
          ) : (
            <p className="course-soon">Próximamente</p>
          )}
        </div>
      ))}
    </div>
  </section>
);

export default Courses;
